const key = (catalogName: string) => `reformat-pending:${catalogName}`;

// Not in catalog props: those are committed, and the draft commit message would reach everyone who pulls.
const reformatPending = {
	mark: (catalogName: string) => {
		try {
			localStorage.setItem(key(catalogName), "1");
		} catch {
			// A browser that refuses storage costs the pre-filled message, nothing else.
		}
	},

	clear: (catalogName: string) => {
		try {
			localStorage.removeItem(key(catalogName));
		} catch {
			// see mark
		}
	},

	is: (catalogName: string) => {
		try {
			return !!catalogName && localStorage.getItem(key(catalogName)) === "1";
		} catch {
			return false;
		}
	},
};

export default reformatPending;
